import {IStore} from '../store';

export const followedArtistIdsSelector: (state: IStore) =>
  ReadonlyArray<string> = (state: IStore) => state.artists.followedArtistIds;

export const isArtistFollowedSelector: (id: string) => (state: IStore) => boolean = (id: string) =>
  (state: IStore) => followedArtistIdsSelector(state).includes(id);
